// extracted by mini-css-extract-plugin
module.exports = {"epvlwq6":"epvlwq6","b11g54l6":"b11g54l6","h1e4nnoh":"h1e4nnoh"};